import { useCallback } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { PerformanceStore } from 'src/store';
import { useChannelAccounts } from 'src/services';
import { CHANNEL } from 'src/data/channel';
import {
  EMAIL_CSV_RESOURCES,
  flatConnectedAccounts,
  shouldChanelConnectManually,
} from 'src/data/performance';
import { SOCIAL_AUTH_STATE } from 'src/data/user';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['authState', 'wtmProjects']);

export const useCheckChannelConnected = () => {
  const { authState, wtmProjects } = usePerformanceState();
  const { connectedAccounts } = useChannelAccounts();

  const getChannelAccounts = useCallback(
    (channel) => {
      if (channel === CHANNEL.projectWtm) {
        return wtmProjects;
      }

      if (!connectedAccounts) {
        return [];
      }

      if (channel === CHANNEL.emailChannel) {
        return flatConnectedAccounts(
          EMAIL_CSV_RESOURCES.map((channel) => {
            return connectedAccounts[channel];
          }).filter((a) => a),
          true
        );
      }

      return connectedAccounts[channel];
    },
    [connectedAccounts, wtmProjects]
  );
  return useCallback(
    (channel) => {
      const isAuthorized = authState[channel] === SOCIAL_AUTH_STATE.authorized;
      if (shouldChanelConnectManually(channel)) {
        return isAuthorized || getChannelAccounts(channel)?.length > 0;
      }
      return isAuthorized;
    },
    [authState, getChannelAccounts]
  );
};
